export interface IPaymentMode {
  CARD?: string;
  NB?: string;
  Emandate?: string;
  VPA?: string;
  UPI?: string;
  UPIRECURRING?: string;
  WALLET_RECURRING?: string;
  WALLET?: string;
  Simpl?: string;
  KETTO_WALLET?: string;
}

export const SIP_PAYMENT_MODE_CONFIG: IPaymentMode = {
  CARD: 'Card',
  NB: 'Net Banking',
  Emandate: 'Net Banking',
  VPA: 'Paytm UPI',
  UPI: 'UPI',
  UPIRECURRING: 'UPI',
  WALLET_RECURRING: 'Paytm Wallet',
  WALLET: 'Wallet',
  Simpl: 'Simpl',
  KETTO_WALLET: 'Ketto Wallet'
};
